type DataType = {
  [key: string]: any;
};

export const removeKeysWithPrefixfromObject = (
  data: DataType,
  prefix: string
) => {
  return Object.fromEntries(
    Object.entries(data).filter(([key]) => !key.startsWith(prefix))
  );
};
